import React from 'react';

import { DevicesViewColumns, DeviceType } from 'utils/constant';
import EditCollectionView from '../../common/EditCollectionView';
import DevicesView from '../DevicesView';

const VehiclesPage = () => {
    return (
        <EditCollectionView 
            content={DevicesView} 
            editPath="vehicle" 
            endpoint="devices" 
            type={DeviceType.VEHICLE} 
            columns={[
                DevicesViewColumns.LABEL,
                DevicesViewColumns.TRACKER_IDENTIFIER,
                DevicesViewColumns.BRAND,
                DevicesViewColumns.MODEL,
                DevicesViewColumns.GROUP,
            ]}
        />
    );
}

export default VehiclesPage;
